// export const API_URL = "https://backoffice-api.suffescom.dev/api/";
export const API_URL = "https://api.smarttaxdocs.com/api/";

export const LOGIN_USER = "admin/adminloginotp";
export const VERIFY_OTP = "admin/admincheckotp";
export const CREATE_PASS_SUBADMIN = "admin/subadminpasswordgenerate";
export const ADMIN_DETAIL = "admin/getsubadmin/";
export const ROW_SORTING = "admin/sort_index";

// export const SELECT_OTP_OPTION = "admin/adminloginsendoptioncheckotp";
export const SELECT_OTP_OPTION = "admin/adminloginotp";


// // ================= DASHBOARD =================== // //
export const DASHBOARD_DETAILS = "adminDashboard/getDashboardList";

// // ================= BOOKINGS  =================== // //
export const BOOKINGS_LIST = "adminDashboard/allBookingsWithFilter";
export const BOOKING_DETAIL = "adminDashboard/bookingDetail/";
export const UPDATE_BOOKING_STATUS = "adminDashboard/updateBookingStatus";

export const POST_CONFIGURE = "admin/updateoptiontable/1";
export const GET_CONFIGURE = "admin/getoptiontable/1";
export const GET_FIELD_DATA = "admin/getoptiontablecombined";

// // ================= ADMIN TRANSACTION  =================== // //
export const ADMIN_TRANSACTION_LIST =
  "adminDashboard/adminTransactionsWithFilter";

// // ================= PROVIDER WITHDRAWL  =================== // //
export const PROVIDER_WITHDRAWL_LIST =
  "adminDashboard/providerWithdrawlsWithFilter";

export const PROCESS_WITHDRAWAL = "adminDashboard/processWithdrawl";

export const CANCEL_WITHDRAWAL = "adminDashboard/cancelWithdrawl";

// // ================= MANAGE_CUSTOMERS =================== // //

export const CUSTOMERS_LIST = "admin/users";
export const EDIT_MANAGE_CUSTOMER = "admin/getuser/";
export const UPDATE_USER = "admin/updateuser/";
export const ADD_USER = "admin/adduserbycall";
export const BLOCK_UNBLOCK_USER = "admin/userstatus/";
export const DELETE_USER = "admin/deleteuser/";
export const EXPORT_USER = "admin/getUsersWithFilter";
export const SEND_EMAIL = "admin/emailsendtosingleuser";
export const SEND_TEXT = "admin/smssendtosingleuser";
export const POST_DOCUMENT_FILE = "admin/userdocument";
export const DELETE_USER_DOCUMENT = "admin/deleteuserdocument/";
export const UPDATE_DOCUMENT_FILE = "admin/updateuserdocument";
export const GET_DOCUMENT_FILE = "admin/getdocuments/";
export const ACCEPT_REJECT_DOCUMENT = "admin/documentstatus";
export const RESET_USER_PASS = "admin/updateuserpassword";
export const ADD_NOTE = "admin/addsentnote";
export const GET_NOTE_BY_ID = "admin/getsentnotebyadmin";
export const UPDATE_NOTE = "admin/updatesentnotebyadmin";
export const GET_SINGLE_NOTE = "admin/getsentnote/";
export const DELETE_NOTE = "admin/deletesentnote/";
export const SMS_HISTORY = "admin/getsentsmsbyadmin";
export const ADD_EMAIL_DRAFT = "admin/addsentemail";
export const DRAFT_EMAIL_LIST = "admin/sentemails";
export const DRAFT_EMAIL_BY_ID = "admin/getsentemail/";

export const SEND_DOCUMENTS_LIST = "admin/getuserpendingdocs/";

// ==================== email signatures =================== //

export const ADD_SIGNATURE = "admin/addemailsignature";
export const GET_SIGNATURE = "admin/emailsignatures";
export const UPDATE_SIGNATURE = "admin/updateemailsignature/";
export const GET_SIGNATURE_BY_ID = "admin/getemailsignature/";
export const DELETE_SIGNATURE = "admin/deleteemailsignature/";

export const GET_MESSAGE_LIST = "admin/contactus";
export const GET_MESSAGE_BY_ID = "admin/getcontactus/";

export const GET_SUBSCRIBER_LIST = "admin/subscriber";
export const GET_SUBSCRIBER_BY_ID = "admin/getsubscriber/";

export const GET_FACEBOOK_LIST = "admin/subscriberfacebook";
export const GET_FACEBOOK_BY_ID = "admin/getsubscriberfacebook/";

export const GET_INSTAGRAM_LIST = "admin/subscriberinstagram";
export const GET_INSTAGRAM_BY_ID = "admin/getsubscriberinstagram/";

export const GET_TWITTER_LIST = "admin/subscribertwitter";
export const GET_TWITTER_BY_ID = "admin/getsubscribertwitter/";

export const GET_YOUTUBE_LIST = "admin/subscriberyoutube";
export const GET_YOUTUBE_BY_ID = "admin/getsubscriberyoutube/";

export const GET_TIKTOK_LIST = "admin/subscribertiktok";
export const GET_TIKTOK_BY_ID = "admin/getsubscribertiktok/";

export const GET_FORM_LIST = "admin/userpdftest";
export const GET_FORM_BY_ID = "admin/getuserpdftest/";

export const GET_FINANCE_LIST = "admin/atsfinancialquestionnaire";
export const GET_FINANCE_BY_ID = "admin/getatsfinancialquestionnaire/";

export const POST_FINANCIAL = "admin/updateatsfinancialquestionnaire/";

// delete social subscribers//

export const DELETE_FACEBOOK = "admin/deletesocialsubscriberfacebookbyids";
export const DELETEALL_FACEBOOK = "admin/deleteallsocialsubscriberfacebook";
export const DELETE_INSTAGRAM = "admin/deletesocialsubscriberinstagrambyids";
export const DELETEALL_INSTAGRAM = "admin/deleteallsocialsubscriberinstagram";
export const DELETE_TWITTER = "admin/deletesocialsubscribertwitterbyids";
export const DELETEALL_TWITTER = "admin/deleteallsocialsubscribertwitter";
export const DELETE_YOUTUBE = "admin/deletesocialsubscriberyoutubebyids";
export const DELETEALL_YOUTUBE = "admin/deleteallsocialsubscriberyoutube";
export const DELETE_TIKTOK = "admin/deletesocialsubscribertiktokbyids";
export const DELETEALL_TIKTOK = "admin/deleteallsocialsubscribertiktok";

export const DELETE_CONTACT = "admin/deletecontactusbyids";
export const DELETEALL_CONTACT = "admin/deleteallcontactus";

export const DELETE_SUBSCRIBER = "admin/deletesubscriberbyids";
export const DELETEALL_SUBSCRIBER = "admin/deleteallsubscriber";

// =============== contact detail ====================//

export const GET_DETAIL_SETTINGS = "admin/getbasicsetting";
export const UPDATE_DETAIL_SETTING = "admin/updatebasicsetting";

// ================ sub admin ===================== //

export const GET_SUBADMIN_LIST = "admin/subadmins";
export const POST_SUBADMIN = "admin/addsubadmin";
export const GET_SUBADMIN_BY_ID = "admin/getsubadmin/";
export const UPDATE_SUBADMIN = "admin/updatesubadmin/";
export const DELETE_SUBADMIN = "admin/deletesubadmin/";
export const RESET_SUBADMIN_PASS = "admin/updatesubadminpassword";
export const DROPDOWN_SUBADMIN = "admin/subadminwithoutsoftdelete";

// ================== ROLE & PERMISSIONS =================== //

export const GET_ROLE_LIST = "admin/rolepermissions";
export const POST_ROLE = "admin/addrolepermission";
export const GET_ROLE_BY_ID = "admin/getrolepermission/";
export const UPDATE_ROLE = "admin/updaterolepermission/";
export const DELETE_ROLE = "admin/deleterolepermission/";

// // ================= MANAGE_CATEGORY =================== // //

export const CATEGORY_LIST = "admin/templatecategories";
export const EDIT_MANAGE_CATEGORY = "admin/gettemplatecategory/";
export const UPDATE_CATEGORY = "admin/updatetemplatecategory/";
export const ADD_CATEGORY = "admin/addtemplatecategory";
export const DELETE_CATEGORY = "admin/deletetemplatecategory/";

// // ================= MANAGE_document_CATEGORY =================== // //

export const DOCUMENT_CATEGORY_LIST = "admin/documentcategories";
export const EDIT_MANAGE_DOCUMENT_CATEGORY = "admin/getdocumentcategory/";
export const UPDATE_DOCUMENT_CATEGORY = "admin/updatedocumentcategory/";
export const ADD_DOCUMENT_CATEGORY = "admin/adddocumentcategory";
export const DELETE_DOCUMENT_CATEGORY = "admin/deletedocumentcategory/";

// // ================= Email template =================== // //

export const EMAIL_TEMP_LIST = "admin/emailtemplates";
export const EMAIL_TEMP_ID = "admin/getemailtemplate/";
export const UPDATE_EMAIL_TEMP = "admin/updatetemailemplate/";
export const ADD_EMAIL_TEMP = "admin/addemailtemplate";
export const DELETE_EMAIL_TEMP = "admin/deleteemailtemplate/";
export const EMAIL_TEMP_BY_TYPE = "admin/getemailtemplatebytype";

// // ================= SMS template =================== // //

export const SMS_TEMP_LIST = "admin/smstemplates";
export const SMS_TEMP_ID = "admin/getsmstemplate/";
export const UPDATE_SMS_TEMP = "admin/updatetsmsemplate/";
export const ADD_SMS_TEMP = "admin/addsmstemplate";
export const DELETE_SMS_TEMP = "admin/deletesmstemplate/";
export const SMS_TEMP_BY_TYPE = "admin/getsmstemplatebytype";

// // ================= MANAGE_DOCUMENTS =================== // //

export const DOCUMENTS_LIST = "admin/documents";
export const EDIT_MANAGE_DOCUMENTS = "admin/getdocument/";
export const UPDATE_DOCUMENTS = "admin/updatedocument/";
export const ADD_DOCUMENTS = "admin/adddocument";
export const DELETE_DOCUMENTS = "admin/deletedocument/";

// // ================= MANAGE_TEMPLATES =================== // //

export const TEMPLATES_LIST = "admin/templates";
export const EDIT_MANAGE_TEMPLATES = "admin/gettemplate/";
export const UPDATE_TEMPLATES = "admin/updatetemplate/";
export const ADD_TEMPLATES = "admin/addtemplate";
export const DELETE_TEMPLATES = "admin/deletetemplate/";

// // ================= FILE_UPLOAD =================== // //
export const FILE_UPLOAD = "admin/uploadfiles";

//================= FAQ_LIST =================== //
export const FAQ_LIST = "admin/getAllFaqs";
export const ADD_FAQ = "admin/addFaq";
export const EDIT_FAQ = "admin/editFaq";
export const FAQ_DETAILS = "admin/getFaqsById/";
export const DELETE_FAQ = "admin/deleteFaq";
// ================= CONTENTPAGE_LIST =================== //
export const CONTENTPAGE_LIST = "admin/contents";
export const CONTENTPAGE_LIST_DETAILS = "admin/contents/edit/";
export const CONTENTPAGE_EDIT = "admin/contents/update";

// ================= SETTINGS =================== //
export const BASIC_SETTING_DETAILS = "admin/emailupdatenotification";
export const GET_BASIC_DETAILS = "admin/emailgetnotification";

//=================PROMOCODE =================== //
export const PROMO_CODE_LIST = "admin/promocodes/getWithFilters";
export const ADD_PROMO_CODE = "admin/promocodes/add";
export const EDIT_PROMO_CODES = "admin/promocodes/edit";
export const PROMO_CODE_DETAILS = "admin/promocodes/getById/";
export const DELETE_PROMO_CODE = "admin/promocodes/delete/";

// ================= ADMIN_LIST =================== //

export const CHANGE_PASS_OTP = "admin/adminpasswordupdatesendotp";
export const CHANGE_PASS_OTP_VERIFY = "admin/adminpasswordupdatecheckotp";
export const CHANGE_PASS_ADMIN = "admin/adminpasswordupdate";

export const ADMIN_LIST = "admin/getAllAdminList";
export const ADD_ADMIN_LIST = "admin/addAdmin";
export const UPDATE_ADMIN_LIST = "admin/updateadminprofileimage/";
export const CHANGE_ADMIN_PASSWORD = "admin/changePassword";

// ================= VEHICLE MAKE =================== //

export const VEHICLE_MAKE_LIST = "vehicleMake/getWithFilter";
export const ADD_VEHICLE_MAKE = "vehicleMake/add";
export const UPDATE_VEHICLE_MAKE = "vehicleMake/update";
export const GET_VEHICLE_MAKE_DETAILS = "vehicleMake/getById/";
export const REMOVE_VEHICLE_MAKE = "vehicleMake/remove";

// ================= VEHICLE MODEL =================== //

export const VEHICLE_MODEL_LIST = "vehicleModel/getWithFilter";
export const ADD_VEHICLE_MODEL = "vehicleModel/add";
export const UPDATE_VEHICLE_MODEL = "vehicleModel/update";
export const GET_VEHICLE_MODEL_DETAILS = "vehicleModel/getById/";
export const REMOVE_VEHICLE_MODEL = "vehicleModel/remove";

// ================= SERVICES =================== //

// export const SERVICE_LIST = "service/getWithFilter";
export const ADD_SERVICE = "service/add";
export const UPDATE_SERVICE = "service/update";
export const GET_SERVICE_DETAILS = "service/getById/";
export const REMOVE_SERVICE = "service/remove";

// ================= SERVICE ADD ON'S =================== //

export const SERVICE_ADDON_LIST = "addOn/getWithFilter";
export const ADD_SERVICE_ADDON = "addOn/add";
export const UPDATE_SERVICE_ADDON = "addOn/update";
export const GET_SERVICE_ADDON_DETAILS = "addOn/getById/";
export const REMOVE_SERVICE_ADDON = "addOn/remove";

// // ================= DISPUTE  =================== // //
export const DISPUTE_LIST = "dispute/getWithFilters";
export const DISPUTE_DETAIL = "dispute/getDetail/";
export const UPDATE_DISPUTE_STATUS = "dispute/updateDisputeStatus";
export const REFUND_DISPUTE = "dispute/refundDispute";
export const SEND_DISPUTE_REPLY = "dispute/sendDisputeReplyByAdmin";

// // ================= CUSTOMER_REPORT_GRAPH  =================== // //

export const CUSTOMER_REPORT_GRAPH = "adminDashboard/customerCountReport";

// // ================= BOOKING_REPORT_GRAPH  =================== // //

export const BOOKING_REPORT_GRAPH = "adminDashboard/bookingGraph";

// =================== SEND EMAIL/SMS TO SUBSCRIBERS =================== //

export const SEND_EMAIL_SUBSCRIBER = "admin/emailsendtosinglesubscriber";
export const SEND_SMS_SUBSCRIBER = "admin/smssendtosinglesubscriber";

export const HEALTH_INSURANCE_LIST = "admin/healthinsurances";
export const GET_HEALTH_INSURANCE = "admin/gethealthinsurance/";

export const CONVERT_TO_IRS = "admin/addusertoirs";

// export const STRIPE_PUBLIC_KEY = "pk_test_LLAdXVApiHYl2QUmtHy2HiHT";

export const EMAIL_REGEX = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
export const PASS_REGEX = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
export const Numeric = /^[0-9]+$/;
export const ALPHABET = /^[A-Za-z]+$/;
export const ALPHANUMERIC_REGEX = /[^a-z\d]/i;
export const PASS_VALIDATION_MSG =
  "password should be at least 8 characters, one uppercase, lowercase, special character (@,-,~,_), numeric value.";
